/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Generate_Report_DescriptionInputs */

const en_audit_generate_report_description = /** @type {(inputs: Audit_Generate_Report_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an audit session and export as CSV.`)
};

const es_audit_generate_report_description = /** @type {(inputs: Audit_Generate_Report_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una sesion de auditoria y exporte como CSV.`)
};

/**
* | output |
* | --- |
* | "Select an audit session and export as CSV." |
*
* @param {Audit_Generate_Report_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_generate_report_description = /** @type {((inputs?: Audit_Generate_Report_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Generate_Report_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_generate_report_description(inputs)
	return es_audit_generate_report_description(inputs)
});